<template style="padding-left:100px;" id="create-user">
    <div class="cUser-container">
            <div class="d-flex w-100 m-auto p-3 justify-content-center flex-column cUser">
                <h2>Create New User</h2><hr>
                <span v-bind:class="{ is_valid : contains_eight_characters, is_not_valid: !contains_eight_characters }">Password Min 8 Characters</span>
                <span v-bind:class="{ is_valid: contains_number, is_not_valid: !contains_number }">Password Contains Number</span>
                <span v-bind:class="{ is_valid: contains_uppercase, is_not_valid: !contains_uppercase }">Password Contains Uppercase</span>
                <span v-bind:class="{ is_valid: contains_special_character, is_not_valid: !contains_special_character }">Password Contains Special Character</span>
                <span v-bind:class="{ is_valid: valid_email, is_not_valid: !valid_email }">User name must be email format</span>
                <span v-bind:class="{ is_valid: valid_mobile, is_not_valid: !valid_mobile }">Mobile must be 10 digits and only numeric</span>

                <div class="alert alert-danger" v-if="checkingConfirmPass">New password and confirm password did not match.</div>

                <form action="#" method="post">
                    <div class="form-group">
                        <label class="float-left">User Name</label>
                        <input type="text" class="form-control" @input="checkEmail"
                               id="" aria-describedby="emailHelp"
                               v-model="userName"
                               ref="userName"
                               required
                               placeholder="*Your corporate email as your user Name">
                    </div>
                    <div class="form-group">
                        <label class="float-left">First Name</label>
                        <input type="text" class="form-control"
                               id="" aria-describedby="emailHelp"
                               v-model="firstName"
                               ref="firstName"
                               required
                               placeholder="*First Name">
                    </div>
                    <div class="form-group">
                        <label class="float-left">Last Name</label>
                        <input type="text" class="form-control"
                               id="" aria-describedby="emailHelp"
                               v-model="lastName"
                               ref="lastName"
                               required
                               placeholder="*Last Name">
                    </div>
                    <div class="form-group">
                        <label class="float-left">User Short Name</label>
                        <input type="text" class="form-control"
                               id="" aria-describedby="emailHelp"
                               v-model="userShortName"
                               ref="userShortName"
                               required
                               placeholder="*User short name">
                    </div>
                    <div class="form-group">
                        <label class="float-left">Mobile Number</label>
                        <input type="text" class="form-control" @input="checkMobile" @keypress="onlyNumbers"
                               id="" aria-describedby="emailHelp"
                               v-model="phoneMobile"
                               ref="phoneMobile"
                               required
                               placeholder="Mobile Number"
                               maxlength="10">
                    </div>
                    <div class="form-group">
                        <label class="float-left">Password</label>
                        <input type="password" @input="checkPassword" class="form-control"
                               id="" aria-describedby="emailHelp"
                               v-model="pwdEncrypted"
                               ref="pwdEncrypted"
                               required
                               placeholder="*Password">
                    </div>
                    <div class="form-group">
                        <label class="float-left">Confirm Password</label>
                        <input type="password" @input="confirmPassword" class="form-control"
                               id="" aria-describedby="emailHelp"
                               v-model="confirmPass"
                               ref="confirmPass"
                               required
                               placeholder="*Confirm password">
                    </div>
                    <button type="reset" class="btn btn-primary mr-3" >Cancel</button>
                    <button type="button" v-on:click="createUser()" class="btn btn-primary ml-3" :disabled='isDisabled'>Create User</button>
                </form>
            </div>
        </div>
</template>
<script>
import axios from 'axios'

export default {
    name: 'createUser',
    data () {
      return {
        userName: null,
        userShortName: null,
        firstName: null,
        lastName: null,
        phoneMobile: null,
        valid_mobile: false,
        email: null,
        valid_email: false,
        pwdEncrypted:null,
        confirmPass: null,
        createUserFailed: false,
        checkingConfirmPass: false,
        /* password validation */
        password_length: 0,
        contains_eight_characters: false,
        contains_number: false,
        contains_uppercase: false,
        contains_special_character: false,
        valid_password: false,
        isDisabled: true,
        updateMsg: null,
        msgColor: null,
        regEmail: /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/ ,
      }
    },

    created: function () {
    },
    methods: {
         onlyNumbers(event) {
               let keyCode = event.keyCode ? event.keyCode : event.which;
               if (keyCode < 48 || keyCode > 57) {
                 event.preventDefault();
               }
         },
         checkMobile() {
               if (this.phoneMobile.length === 10) {
                this.valid_mobile = true
               }
               else {
                this.valid_mobile = false
               }
         },
         checkEmail() {
               if (this.regEmail.test(this.userName)) {
                this.valid_email = true
               }
               else {
                this.valid_email = false
               }
         },
         checkPassword() {
              this.password_length = this.pwdEncrypted.length;
              const format= /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>?]/;

              if (this.password_length >= 8) {
                this.contains_eight_characters = true;
              } else {
                    this.contains_eight_characters = false;
              }
              this.contains_number = /\d/.test(this.pwdEncrypted);
              this.contains_uppercase = /[A-Z]/.test(this.pwdEncrypted);
              this.contains_special_character = format.test(this.pwdEncrypted);

              if (this.contains_eight_characters === true && this.contains_special_character === true &&
                  this.contains_uppercase === true && this.contains_number === true) {
                    this.valid_password = true;
              } else {
                    this.valid_password = false;
              }
         },
         confirmPassword: function () {
            if(this.pwdEncrypted=== this.confirmPass) {
                  this.checkingConfirmPass= false
                  if (this.valid_password === true && this.pwdEncrypted=== this.confirmPass)
                    this.isDisabled= false
            }
            else {
                this.checkingConfirmPass= true
                this.isDisabled= true
            }
            console.warn("confirm password: ", this.confirmPass)
         },
         cancleData: function() {
                 this.userName= "",
                 this.email= "",
                 this.firstName= "",
                 this.lastName= "",
                 this.userShortName= "",
                 this.phoneMobile= "",
                 this.pwdEncrypted= "",
                 this.isDisabled= true
         },
         createUser: function () {
            this.createUserFailed = false
            this.$store.state.authRequired = false
            var formData = {
                userName: this.userName,
                email: this.userName,
                firstName: this.firstName,
                lastName: this.lastName,
                userShortName: this.userShortName,
                phoneMobile: this.phoneMobile,
                pwdEncrypted: this.pwdEncrypted,
            };
            console.log("formData:", formData)
            axios.post(`/api/create-user`, formData).then((response) => {
                console.log("this.data: ", response.data)
                this.msgColor= 'green'
                alert(this.updateMsg= 'New user created successfully')

                this.userName= "",
                this.email= "",
                this.firstName= "",
                this.lastName= "",
                this.userShortName= "",
                this.phoneMobile= "",
                this.pwdEncrypted= "",
                this.confirmPassword= "",
                this.isDisabled= true
            }, error => {
                  alert(this.updateMsg= error.response && error.response.data ? error.response.data.title : '')
                  this.msgColor= 'red'
                  this.errorTitle = error.response && error.response.data ? error.response.data.title : ''
                  this.$store.commit('authError')
                  this.createUserFailed = !this.$store.state.serverIsDown
            })
      }
    }
  }
</script>
<style scoped>
    .cUser-container {
        display: flex;
        width: 100vh;
        height: 75vh;
        justify-content: center;
        align-content: center;
        align-items: center;
        align-self: center;
        padding-top: 50px;
    }

    .cUser {
        box-shadow: 1px 2px 2px 3px #a7aeaa;
    }

    .cUser {
        box-shadow: 1px 2px 2px 3px #a7aeaa;
    }
    .is_valid { color: green }
    .is_not_valid { color: red }
    .btn.btn[disabled] { color: black; }
</style>